import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Moderation from './Index.vue';
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/moderation'),
      component: SettingsWrapper,
      props: { keepAlive: false },
      meta: { permissions: ['administrator'] },
      children: [
        {
          path: '',
          name: 'telegram_moderation_settings',
          component: Moderation,
          meta: { permissions: ['administrator'] },
        },
      ],
    },
  ],
};
